import { useTranslation } from '@presentation/utils';
import type { FC } from 'react';
import { Button, PreferenceList, SectionSubtitle } from '..';
import * as Styled from './styled';
import type { MtSocialProvidersProps } from './types';
import { MtSocialProviderType } from './types';

export * from './types';

const TYPE_NAME: Record<MtSocialProviderType, string> = {
  FACEBOOK: 'Facebook',
  FIREBASE: 'Email',
  GOOGLE: 'Google',
};

export const MtSocialProviders: FC<MtSocialProvidersProps> = (props) => {
  const { linkedTypes = [], onClick, currentType, loading } = props;
  const { translate } = useTranslation();

  return (
    <>
      <SectionSubtitle>{translate('mt.preferences.accounts')}</SectionSubtitle>

      {(Object.keys(MtSocialProviderType) as MtSocialProviderType[]).map((type) => {
        const isLinked = linkedTypes.includes(type);
        const isCurrent = currentType === type;

        return (
          <PreferenceList.Item key={type}>
            <PreferenceList.PLabel>
              <span>{TYPE_NAME[type]}</span>
              {isCurrent && (
                <Styled.ActiveLabel>({translate('glossary.active')})</Styled.ActiveLabel>
              )}
            </PreferenceList.PLabel>
            {!isCurrent && (
              <Button
                onClick={() => onClick(type)}
                color={isLinked ? 'red' : 'blue'}
                shrink
                size="small"
                loading={loading}
                disabled={isCurrent}
              >
                {translate(`common.buttons.${isLinked ? 'unlinkAccount' : 'linkAccount'}`)}
              </Button>
            )}
          </PreferenceList.Item>
        );
      })}
    </>
  );
};
